import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiUsers, FiCheckCircle, FiClipboard, FiFileText, FiChevronRight } from 'react-icons/fi';
import DashboardLayout from '../../components/layout/DashboardLayout';
import StatCard from '../../components/ui/StatCard';
import SectionCard from '../../components/ui/SectionCard';
import ListItem from '../../components/ui/ListItem';
import { useAuth } from '../../context/AuthContext';
import { getAdminStats } from '../../services/statsService';

export default function AdminDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let active = true;
    getAdminStats().then((data) => {
      if (active) setStats(data);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <DashboardLayout title={`Hola, ${user.name.split(' ')[0]}`} subtitle="Administrador · Panel general">
      <section className="kpi-grid">
        <StatCard icon={<FiUsers />} value={stats?.totalUsers ?? '—'} label="Usuarios" tone="muted" />
        <StatCard icon={<FiCheckCircle />} value={stats?.activeUsers ?? '—'} label="Activos" tone="success" />
        <StatCard icon={<FiClipboard />} value={stats?.activeForms ?? '—'} label="Formularios activos" />
        <StatCard icon={<FiFileText />} value={stats?.totalSubmissions ?? '—'} label="Registros totales" tone="warning" />
      </section>

      <SectionCard title="Gestión">
        <ListItem
          as={Link}
          to="/admin/users"
          icon={<FiUsers />}
          title="Usuarios"
          meta="Roles y permisos"
          right={<FiChevronRight />}
        />
        <ListItem
          as={Link}
          to="/admin/forms"
          icon={<FiClipboard />}
          title="Formularios"
          meta="Plantillas de captura"
          right={<FiChevronRight />}
        />
      </SectionCard>
    </DashboardLayout>
  );
}
